import { Theme } from '@mui/material';

const Input = (theme: Theme) => {
  return {
    MuiInputLabel: {
      defaultProps: {
        shrink: true,
        variant: 'standard',
      },
      styleOverrides: {
        root: {
          position: 'relative',
          fontSize: theme.typography.pxToRem(14),
          transform: 'none',
        },
      },
    },
    MuiOutlinedInput: {
      defaultProps: {
        notched: false,
      },
      styleOverrides: {
        root: {
          fontSize: theme.typography.pxToRem(14),
          height: 42,
          '&.Mui-disabled.Mui-disabled fieldset': {
            opacity: 0.3,
            cursor: 'not-allowed',
            pointerEvents: 'all',
          },
        },
      },
    },
  };
};

export default Input;
